<template>
  <div v-if="shouldShowComponent" class="todays-card-delivery">
    <div v-if="isLoading">로딩 중...</div>
    <div v-else-if="error">에러 발생: {{ error }}</div>
    <template v-else-if="cardDeliveryDeposits">
      <div class="title">
        <div class="text-wrapper">오늘의 카드배달 입금 내역(선정산 상환용)</div>
      </div>
      <div class="div">
        <div class="text-wrapper-2">
          입금 예정액
          <v-btn icon small @click="toggleExpectedDepositInfo">
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </div>
        <div class="text-wrapper-3">{{ commaFormat(cardDeliveryDeposits.expectedDepositAmount) }}원</div>
      </div>
      <v-expand-transition>
        <div v-if="showExpectedDepositInfo" class="expected-deposit-info">
          <div class="info-box">
            <p class="font-size--12">과거 받으신 선정산의 상환을 위해 당사로 오늘 입금될 것으로 예상되었던 카드/배달 매출 금액입니다.</p>
            <p class="font-size--12">입금 예정액은 선정산 실행시에 계산된 값으로서 카드사 수수료, 배달사의 마케팅 비용 차감 등에 의해 실제 입금액과 차이가 있을 수 있습니다.</p>
            <p class="font-size--12">실제 입금액이 입금 예정액보다 부족한 경우에는 기존 선정산의 상황이 완료되지 않으므로, 이후의 선정산 실행 시에 부족액을 차감하게 됩니다.</p><p></p>
          </div>
        </div>
      </v-expand-transition>
      <div class="div">
        <div class="text-wrapper-2">실입금액</div>
        <div class="text-wrapper-3">{{ $filters.commaFormat(cardDeliveryDeposits.actualDepositAmount) }}원</div>
      </div>
      <div class="variance-amount">
        <div class="div">
          <div class="text-wrapper-4">차액</div>
          <div class="text-wrapper-5">{{ cardDeliveryDeposits.depositDifference > 0 ? '(+)' : '' }}{{ commaFormat(cardDeliveryDeposits.depositDifference) }}원</div>
        </div>
        <div class="frame">
          <p class="p" style="margin: 0; text-align: left;">
            <span :style="{ color: cardDeliveryDeposits.depositDifference < 0 ? 'red' : 'black' }">
              * 차액이 (-)인 경우는, 선정산 상환이 부족해진 경우이므로 다음 선정산시 "카드배달 입금부족액"으로 차감됩니다.
            </span>
            <br />
            <span :style="{ color: cardDeliveryDeposits.depositDifference < 0 ? 'black' : 'red' }">
              * 차액이 (+)인 경우는, 선정산 상환용보다 더 큰 금액이 입금된 경우이므로 당일 오후 고객에게 반환됩니다.
            </span>
          </p>
        </div>
        <div v-if="cardDeliveryDeposits.depositDifference !== 0 && isShowDepositDifferenceBreakdown" class="frame-2" style="margin-top: 10px;">
          <div class="text-wrapper-6">[차액의 구성]</div>
          <div v-for="(item, index) in cardDeliveryDeposits.depositDifferenceBreakdown" :key="index" class="frame-3">
            <div class="text-wrapper-7">{{ item.reason }}</div>
            <div class="text-wrapper-8">
              {{ commaFormat(item.amount) }}원
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { mapActions } from 'vuex';
import { commaFormat } from '@/filter/number'

export default defineComponent({
  name: "TodaysCardDeliveryDeposits",
  props: {
    date: {
      type: String,
      required: true,
    },
    isShowDepositDifferenceBreakdown: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      cardDeliveryDeposits: null,
      isLoading: true,
      error: null,
      showExpectedDepositInfo: false,
    };
  },
  computed: {
    shouldShowComponent() {
      return this.cardDeliveryDeposits && 
             this.cardDeliveryDeposits.expectedDepositAmount !== undefined &&
             this.cardDeliveryDeposits.expectedDepositAmount !== null;
    },
    result() {
      if (this.cardDeliveryDeposits) {
        return {
          cardDeliveryDeposits: this.cardDeliveryDeposits
        };
      }
      return null;
    }
  },
  async created() {
    this.isLoading = true;
    try {
      this.cardDeliveryDeposits = await this.getCardDeliveryDeposits(this.date);
    } catch (error) {
      this.error = error.message;
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    ...mapActions('earlyPayment', ['getCardDeliveryDeposits']),
    commaFormat,
    toggleExpectedDepositInfo() {
      this.showExpectedDepositInfo = !this.showExpectedDepositInfo;
    },
  },
  watch: {
    date() {
      this.fetchData();
    },
    shouldShowComponent(newValue) {
      this.$emit('shouldShow', newValue);
    }
  },
  render() {
    return this.$scopedSlots.default({
      data: this.result,
      isLoading: this.isLoading,
      error: this.error
    });
  }
});
</script>

<style scoped>
.todays-card-delivery {
  align-items: flex-start;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 0px;
  padding: 0;
  position: relative;
  border-radius: 0px;
}

.todays-card-delivery .title {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 5px;
  justify-content: center;
  position: relative;
  margin-bottom: 20px; /* 이 줄을 추가합니다 */
}

.todays-card-delivery .text-wrapper {
  color: #5a5a5a;
  font-family: "Inter-Bold", Helvetica;
  font-size: 16px;
  font-weight: 1000;
  letter-spacing: 0;
  line-height: 35px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.todays-card-delivery .div {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.todays-card-delivery .text-wrapper-2 {
  color: #666666;
  font-family: "Inter-Regular", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.todays-card-delivery .text-wrapper-3 {
  color: #666666;
  font-family: "Inter-Bold", Helvetica;
  font-size: 16px;
  font-weight: 1000;
  letter-spacing: 0;
  line-height: 35px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.todays-card-delivery .variance-amount {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 5px;
  position: relative;
  width: 100%;
}

.todays-card-delivery .text-wrapper-4 {
  color: #fe8100;
  font-family: "Inter-Regular", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 35px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.todays-card-delivery .text-wrapper-5 {
  color: #fe8100;
  font-family: "Inter-Bold", Helvetica;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 35px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.todays-card-delivery .frame {
  align-items: center;
  align-self: stretch;
  background-color: #eaeaea;
  display: flex;
  flex: 0 0 auto;
  gap: 10px;
  justify-content: center;
  padding: 9px;
  position: relative;
  width: 100%;
}

.todays-card-delivery .p {
  color: #ff8100;
  flex: 1;
  font-family: "Inter-Regular", Helvetica;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: -1px;
  position: relative;
  text-align: left;
}

.todays-card-delivery .frame-2 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  position: relative;
  width: 100%;
}

.todays-card-delivery .text-wrapper-6 {
  align-self: stretch;
  color: #323232;
  font-family: "Inter-Bold", Helvetica;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 35px;
  margin-top: -1px;
  position: relative;
}

.todays-card-delivery .frame-3 {
  align-items: center;
  align-self: stretch;
  display: flex;
  height: 26px;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.todays-card-delivery .text-wrapper-7 {
  color: #666666;
  font-family: "Inter-Regular", Helvetica;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.todays-card-delivery .text-wrapper-8 {
  color: #666666;
  font-family: "Inter-Bold", Helvetica;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.expected-deposit-info {
  margin-top: 10px;
  margin-bottom: 10px;
}

.info-box {
  background-color: #f8f8f8;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 15px;
}

.info-box p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.info-box p:first-child {
  margin-bottom: 8px;
}
</style>
